export default [
    {
        name: 'listarImpostosContabilidade',
        path: '/contabilidade/impostos',
        alias: '/contabilidade/impostos/index',
        component: () => import('../views/Listar')
    }
]
